import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { AthleteGLMLinkStatus, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export const athleteGLMStatusKey = (athleteId: string): unknown[] => ['athlete-glm-status', athleteId];

/**
 * Current Kilo ↔ GLM link state for an athlete (powers the athlete-detail link card).
 */
export default function useAthleteGLMStatus(
  athleteId: string | null,
  enabled = true,
): UseQueryResult<AxiosResponse<AthleteGLMLinkStatus>, AxiosError<ErrorMessage>> {
  return useQuery(
    athleteGLMStatusKey(athleteId ?? ''),
    () => client.get<AthleteGLMLinkStatus>(`athletes/${athleteId}/glm/status/`),
    {
      enabled: !!athleteId && enabled,
    },
  );
}
